
if (import.meta.hot) {
  import.meta.hot.accept((mod) => {
    const router = import.meta.hot.data.router
    const generateRoutes = import.meta.hot.data.generateRoutes
    if (!router || !generateRoutes) {
      import.meta.hot.invalidate('[nuxt] Cannot replace routes because there is no active router. Reloading.')
      return
    }
    router.clearRoutes()
    const routes = generateRoutes(mod.default || mod)
    function addRoutes (routes) {
      for (const route of routes) {
        router.addRoute(route)
      }
      router.replace(router.currentRoute.value.fullPath)
    }
    if (routes && 'then' in routes) {
      routes.then(addRoutes)
    } else {
      addRoutes(routes)
    }
  })
}

export function handleHotUpdate(_router, _generateRoutes) {
  if (import.meta.hot) {
    import.meta.hot.data ||= {}
    import.meta.hot.data.router = _router
    import.meta.hot.data.generateRoutes = _generateRoutes
  }
}
import { default as indexyIMf91YAU2Meta } from "/var/www/pec-uz.uz/www/frontend/pages/[page]/index.vue?macro=true";
import { default as about6obWmWz5YNMeta } from "/var/www/pec-uz.uz/www/frontend/pages/about.vue?macro=true";
import { default as hidden_indexyrR78AqpOoMeta } from "/var/www/pec-uz.uz/www/frontend/pages/documents/hidden_index.vue?macro=true";
import { default as errorg6idlFwizdMeta } from "/var/www/pec-uz.uz/www/frontend/pages/error.vue?macro=true";
import { default as BlockFaqbTmjyPMHKMMeta } from "/var/www/pec-uz.uz/www/frontend/pages/franchise/components/BlockFaq.vue?macro=true";
import { default as ConsultationBlockWYd79Uh2ucMeta } from "/var/www/pec-uz.uz/www/frontend/pages/franchise/components/ConsultationBlock.vue?macro=true";
import { default as ConsultationForm5YqWXL0gH9Meta } from "/var/www/pec-uz.uz/www/frontend/pages/franchise/components/ConsultationForm.vue?macro=true";
import { default as FilialOpenxgrqsCvyouMeta } from "/var/www/pec-uz.uz/www/frontend/pages/franchise/components/FilialOpen.vue?macro=true";
import { default as FranchiseBlockmsHe4bed2SMeta } from "/var/www/pec-uz.uz/www/frontend/pages/franchise/components/FranchiseBlock.vue?macro=true";
import { default as MapBlockrQyFuYTszhMeta } from "/var/www/pec-uz.uz/www/frontend/pages/franchise/components/mapBlock/MapBlock.vue?macro=true";
import { default as PalletBlockvaFVO7wj0OMeta } from "/var/www/pec-uz.uz/www/frontend/pages/franchise/components/mapBlock/PalletBlock.vue?macro=true";
import { default as ModalError2SOkMBKNPOMeta } from "/var/www/pec-uz.uz/www/frontend/pages/franchise/components/ModalError.vue?macro=true";
import { default as ModalSuccessdrc2nghR2AMeta } from "/var/www/pec-uz.uz/www/frontend/pages/franchise/components/ModalSuccess.vue?macro=true";
import { default as PalletBlockonnsphDhwKMeta } from "/var/www/pec-uz.uz/www/frontend/pages/franchise/components/pallet/PalletBlock.vue?macro=true";
import { default as PalletOnejtLqkLLjuEMeta } from "/var/www/pec-uz.uz/www/frontend/pages/franchise/components/pallet/PalletOne.vue?macro=true";
import { default as BlockDescriptionedWyIjxMvbMeta } from "/var/www/pec-uz.uz/www/frontend/pages/franchise/components/partnerBlock/BlockDescription.vue?macro=true";
import { default as PartnersBlockfUA3GxPKmQMeta } from "/var/www/pec-uz.uz/www/frontend/pages/franchise/components/partnerBlock/PartnersBlock.vue?macro=true";
import { default as PalletBlockhjug2quHiGMeta } from "/var/www/pec-uz.uz/www/frontend/pages/franchise/components/pekPlus/PalletBlock.vue?macro=true";
import { default as PekPlusBlockmZqlg8E0RCMeta } from "/var/www/pec-uz.uz/www/frontend/pages/franchise/components/pekPlus/PekPlusBlock.vue?macro=true";
import { default as indexndRSaEq6AvMeta } from "/var/www/pec-uz.uz/www/frontend/pages/franchise/index.vue?macro=true";
import { default as AdvantageBlock6Afp4QICfMMeta } from "/var/www/pec-uz.uz/www/frontend/pages/index/components/AdvantageBlock.vue?macro=true";
import { default as BannerSliderATid0QcL20Meta } from "/var/www/pec-uz.uz/www/frontend/pages/index/components/BannerSlider.vue?macro=true";
import { default as BlockTitlevrXK1jrvGhMeta } from "/var/www/pec-uz.uz/www/frontend/pages/index/components/BlockTitle.vue?macro=true";
import { default as ConsultationBlocktjzoxgZag0Meta } from "/var/www/pec-uz.uz/www/frontend/pages/index/components/ConsultationBlock.vue?macro=true";
import { default as ConsultationFormKueGgbWpavMeta } from "/var/www/pec-uz.uz/www/frontend/pages/index/components/ConsultationForm.vue?macro=true";
import { default as ModalErrorTB3jk8qFFPMeta } from "/var/www/pec-uz.uz/www/frontend/pages/index/components/ModalError.vue?macro=true";
import { default as ModalSuccessx2AFfvJWI8Meta } from "/var/www/pec-uz.uz/www/frontend/pages/index/components/ModalSuccess.vue?macro=true";
import { default as indexscL9IOWxdOMeta } from "/var/www/pec-uz.uz/www/frontend/pages/index/index.vue?macro=true";
import { default as DefaultAdvantagesSectiontZZeHsfI81Meta } from "/var/www/pec-uz.uz/www/frontend/pages/index/sections/DefaultAdvantagesSection.vue?macro=true";
import { default as DefaultHeaderSectionD1TUZnBuZgMeta } from "/var/www/pec-uz.uz/www/frontend/pages/index/sections/DefaultHeaderSection.vue?macro=true";
import { default as DescriptionSection4tJrch9BJlMeta } from "/var/www/pec-uz.uz/www/frontend/pages/index/sections/DescriptionSection.vue?macro=true";
import { default as FaqSectionwNie8fOXEZMeta } from "/var/www/pec-uz.uz/www/frontend/pages/index/sections/FaqSection.vue?macro=true";
import { default as InfoSectionquADJY0AF8Meta } from "/var/www/pec-uz.uz/www/frontend/pages/index/sections/InfoSection.vue?macro=true";
import { default as MapSectionGsY6fhvVd4Meta } from "/var/www/pec-uz.uz/www/frontend/pages/index/sections/MapSection.vue?macro=true";
import { default as getAddressInfolk14Jrc2G9Meta } from "/var/www/pec-uz.uz/www/frontend/pages/index/utils/getAddressInfo.js?macro=true";
import { default as getDirectionParamsFromAddressInfo96H0OIvYReMeta } from "/var/www/pec-uz.uz/www/frontend/pages/index/utils/getDirectionParamsFromAddressInfo.js?macro=true";
import { default as getNeedCalculatedPL7vZ9KrgMeta } from "/var/www/pec-uz.uz/www/frontend/pages/index/utils/getNeedCalculate.js?macro=true";
import { default as getSugggestzKIZhsfMTtMeta } from "/var/www/pec-uz.uz/www/frontend/pages/index/utils/getSugggest.js?macro=true";
import { default as getTransitCostBlockMessage2WtCxj9OqpMeta } from "/var/www/pec-uz.uz/www/frontend/pages/index/utils/getTransitCostBlockMessage.js?macro=true";
import { default as isProductCodefSdxVvFbDeMeta } from "/var/www/pec-uz.uz/www/frontend/pages/index/utils/isProductCode.js?macro=true";
import { default as _91id_93R8DA5OsUbSMeta } from "/var/www/pec-uz.uz/www/frontend/pages/news/[id].vue?macro=true";
import { default as index220KgIhFRnMeta } from "/var/www/pec-uz.uz/www/frontend/pages/news/index.vue?macro=true";
import { default as Categoryv5GnD0m0EhMeta } from "/var/www/pec-uz.uz/www/frontend/pages/package/components/Category.vue?macro=true";
import { default as CategoryPalletZoR6xBl7WDMeta } from "/var/www/pec-uz.uz/www/frontend/pages/package/components/CategoryPallet.vue?macro=true";
import { default as PalletBlocktYuSpeoSFRMeta } from "/var/www/pec-uz.uz/www/frontend/pages/package/components/PalletBlock.vue?macro=true";
import { default as HeadWithSearchzykwUoD20nMeta } from "/var/www/pec-uz.uz/www/frontend/pages/package/components/TableSearch/HeadWithSearch.vue?macro=true";
import { default as TableBlockZ1CV9Mnh3mMeta } from "/var/www/pec-uz.uz/www/frontend/pages/package/components/TableSearch/TableBlock.vue?macro=true";
import { default as TableRowG0GaivtRT6Meta } from "/var/www/pec-uz.uz/www/frontend/pages/package/components/TableSearch/TableRow.vue?macro=true";
import { default as TableSearchjZaSLTXJyUMeta } from "/var/www/pec-uz.uz/www/frontend/pages/package/components/TableSearch/TableSearch.vue?macro=true";
import { default as indexYrZBG6d2pZMeta } from "/var/www/pec-uz.uz/www/frontend/pages/package/index.vue?macro=true";
export default [
  {
    name: "page___uz",
    path: "/:page()",
    meta: indexyIMf91YAU2Meta || {},
    component: () => import("/var/www/pec-uz.uz/www/frontend/pages/[page]/index.vue")
  },
  {
    name: "page___en",
    path: "/en/:page()",
    meta: indexyIMf91YAU2Meta || {},
    component: () => import("/var/www/pec-uz.uz/www/frontend/pages/[page]/index.vue")
  },
  {
    name: "page___ru",
    path: "/ru/:page()",
    meta: indexyIMf91YAU2Meta || {},
    component: () => import("/var/www/pec-uz.uz/www/frontend/pages/[page]/index.vue")
  },
  {
    name: "about___uz",
    path: "/about",
    component: () => import("/var/www/pec-uz.uz/www/frontend/pages/about.vue")
  },
  {
    name: "about___en",
    path: "/en/about",
    component: () => import("/var/www/pec-uz.uz/www/frontend/pages/about.vue")
  },
  {
    name: "about___ru",
    path: "/ru/about",
    component: () => import("/var/www/pec-uz.uz/www/frontend/pages/about.vue")
  },
  {
    name: "documents-hidden_index___uz",
    path: "/documents/hidden_index",
    component: () => import("/var/www/pec-uz.uz/www/frontend/pages/documents/hidden_index.vue")
  },
  {
    name: "documents-hidden_index___en",
    path: "/en/documents/hidden_index",
    component: () => import("/var/www/pec-uz.uz/www/frontend/pages/documents/hidden_index.vue")
  },
  {
    name: "documents-hidden_index___ru",
    path: "/ru/documents/hidden_index",
    component: () => import("/var/www/pec-uz.uz/www/frontend/pages/documents/hidden_index.vue")
  },
  {
    name: "error___uz",
    path: "/error",
    component: () => import("/var/www/pec-uz.uz/www/frontend/pages/error.vue")
  },
  {
    name: "error___en",
    path: "/en/error",
    component: () => import("/var/www/pec-uz.uz/www/frontend/pages/error.vue")
  },
  {
    name: "error___ru",
    path: "/ru/error",
    component: () => import("/var/www/pec-uz.uz/www/frontend/pages/error.vue")
  },
  {
    name: "franchise-components-BlockFaq___uz",
    path: "/franchise/components/BlockFaq",
    component: () => import("/var/www/pec-uz.uz/www/frontend/pages/franchise/components/BlockFaq.vue")
  },
  {
    name: "franchise-components-BlockFaq___en",
    path: "/en/franchise/components/BlockFaq",
    component: () => import("/var/www/pec-uz.uz/www/frontend/pages/franchise/components/BlockFaq.vue")
  },
  {
    name: "franchise-components-BlockFaq___ru",
    path: "/ru/franchise/components/BlockFaq",
    component: () => import("/var/www/pec-uz.uz/www/frontend/pages/franchise/components/BlockFaq.vue")
  },
  {
    name: "franchise-components-ConsultationBlock___uz",
    path: "/franchise/components/ConsultationBlock",
    component: () => import("/var/www/pec-uz.uz/www/frontend/pages/franchise/components/ConsultationBlock.vue")
  },
  {
    name: "franchise-components-ConsultationBlock___en",
    path: "/en/franchise/components/ConsultationBlock",
    component: () => import("/var/www/pec-uz.uz/www/frontend/pages/franchise/components/ConsultationBlock.vue")
  },
  {
    name: "franchise-components-ConsultationBlock___ru",
    path: "/ru/franchise/components/ConsultationBlock",
    component: () => import("/var/www/pec-uz.uz/www/frontend/pages/franchise/components/ConsultationBlock.vue")
  },
  {
    name: "franchise-components-ConsultationForm___uz",
    path: "/franchise/components/ConsultationForm",
    component: () => import("/var/www/pec-uz.uz/www/frontend/pages/franchise/components/ConsultationForm.vue")
  },
  {
    name: "franchise-components-ConsultationForm___en",
    path: "/en/franchise/components/ConsultationForm",
    component: () => import("/var/www/pec-uz.uz/www/frontend/pages/franchise/components/ConsultationForm.vue")
  },
  {
    name: "franchise-components-ConsultationForm___ru",
    path: "/ru/franchise/components/ConsultationForm",
    component: () => import("/var/www/pec-uz.uz/www/frontend/pages/franchise/components/ConsultationForm.vue")
  },
  {
    name: "franchise-components-FilialOpen___uz",
    path: "/franchise/components/FilialOpen",
    component: () => import("/var/www/pec-uz.uz/www/frontend/pages/franchise/components/FilialOpen.vue")
  },
  {
    name: "franchise-components-FilialOpen___en",
    path: "/en/franchise/components/FilialOpen",
    component: () => import("/var/www/pec-uz.uz/www/frontend/pages/franchise/components/FilialOpen.vue")
  },
  {
    name: "franchise-components-FilialOpen___ru",
    path: "/ru/franchise/components/FilialOpen",
    component: () => import("/var/www/pec-uz.uz/www/frontend/pages/franchise/components/FilialOpen.vue")
  },
  {
    name: "franchise-components-FranchiseBlock___uz",
    path: "/franchise/components/FranchiseBlock",
    component: () => import("/var/www/pec-uz.uz/www/frontend/pages/franchise/components/FranchiseBlock.vue")
  },
  {
    name: "franchise-components-FranchiseBlock___en",
    path: "/en/franchise/components/FranchiseBlock",
    component: () => import("/var/www/pec-uz.uz/www/frontend/pages/franchise/components/FranchiseBlock.vue")
  },
  {
    name: "franchise-components-FranchiseBlock___ru",
    path: "/ru/franchise/components/FranchiseBlock",
    component: () => import("/var/www/pec-uz.uz/www/frontend/pages/franchise/components/FranchiseBlock.vue")
  },
  {
    name: "franchise-components-mapBlock-MapBlock___uz",
    path: "/franchise/components/mapBlock/MapBlock",
    component: () => import("/var/www/pec-uz.uz/www/frontend/pages/franchise/components/mapBlock/MapBlock.vue")
  },
  {
    name: "franchise-components-mapBlock-MapBlock___en",
    path: "/en/franchise/components/mapBlock/MapBlock",
    component: () => import("/var/www/pec-uz.uz/www/frontend/pages/franchise/components/mapBlock/MapBlock.vue")
  },
  {
    name: "franchise-components-mapBlock-MapBlock___ru",
    path: "/ru/franchise/components/mapBlock/MapBlock",
    component: () => import("/var/www/pec-uz.uz/www/frontend/pages/franchise/components/mapBlock/MapBlock.vue")
  },
  {
    name: "franchise-components-mapBlock-PalletBlock___uz",
    path: "/franchise/components/mapBlock/PalletBlock",
    component: () => import("/var/www/pec-uz.uz/www/frontend/pages/franchise/components/mapBlock/PalletBlock.vue")
  },
  {
    name: "franchise-components-mapBlock-PalletBlock___en",
    path: "/en/franchise/components/mapBlock/PalletBlock",
    component: () => import("/var/www/pec-uz.uz/www/frontend/pages/franchise/components/mapBlock/PalletBlock.vue")
  },
  {
    name: "franchise-components-mapBlock-PalletBlock___ru",
    path: "/ru/franchise/components/mapBlock/PalletBlock",
    component: () => import("/var/www/pec-uz.uz/www/frontend/pages/franchise/components/mapBlock/PalletBlock.vue")
  },
  {
    name: "franchise-components-ModalError___uz",
    path: "/franchise/components/ModalError",
    component: () => import("/var/www/pec-uz.uz/www/frontend/pages/franchise/components/ModalError.vue")
  },
  {
    name: "franchise-components-ModalError___en",
    path: "/en/franchise/components/ModalError",
    component: () => import("/var/www/pec-uz.uz/www/frontend/pages/franchise/components/ModalError.vue")
  },
  {
    name: "franchise-components-ModalError___ru",
    path: "/ru/franchise/components/ModalError",
    component: () => import("/var/www/pec-uz.uz/www/frontend/pages/franchise/components/ModalError.vue")
  },
  {
    name: "franchise-components-ModalSuccess___uz",
    path: "/franchise/components/ModalSuccess",
    component: () => import("/var/www/pec-uz.uz/www/frontend/pages/franchise/components/ModalSuccess.vue")
  },
  {
    name: "franchise-components-ModalSuccess___en",
    path: "/en/franchise/components/ModalSuccess",
    component: () => import("/var/www/pec-uz.uz/www/frontend/pages/franchise/components/ModalSuccess.vue")
  },
  {
    name: "franchise-components-ModalSuccess___ru",
    path: "/ru/franchise/components/ModalSuccess",
    component: () => import("/var/www/pec-uz.uz/www/frontend/pages/franchise/components/ModalSuccess.vue")
  },
  {
    name: "franchise-components-pallet-PalletBlock___uz",
    path: "/franchise/components/pallet/PalletBlock",
    component: () => import("/var/www/pec-uz.uz/www/frontend/pages/franchise/components/pallet/PalletBlock.vue")
  },
  {
    name: "franchise-components-pallet-PalletBlock___en",
    path: "/en/franchise/components/pallet/PalletBlock",
    component: () => import("/var/www/pec-uz.uz/www/frontend/pages/franchise/components/pallet/PalletBlock.vue")
  },
  {
    name: "franchise-components-pallet-PalletBlock___ru",
    path: "/ru/franchise/components/pallet/PalletBlock",
    component: () => import("/var/www/pec-uz.uz/www/frontend/pages/franchise/components/pallet/PalletBlock.vue")
  },
  {
    name: "franchise-components-pallet-PalletOne___uz",
    path: "/franchise/components/pallet/PalletOne",
    component: () => import("/var/www/pec-uz.uz/www/frontend/pages/franchise/components/pallet/PalletOne.vue")
  },
  {
    name: "franchise-components-pallet-PalletOne___en",
    path: "/en/franchise/components/pallet/PalletOne",
    component: () => import("/var/www/pec-uz.uz/www/frontend/pages/franchise/components/pallet/PalletOne.vue")
  },
  {
    name: "franchise-components-pallet-PalletOne___ru",
    path: "/ru/franchise/components/pallet/PalletOne",
    component: () => import("/var/www/pec-uz.uz/www/frontend/pages/franchise/components/pallet/PalletOne.vue")
  },
  {
    name: "franchise-components-partnerBlock-BlockDescription___uz",
    path: "/franchise/components/partnerBlock/BlockDescription",
    component: () => import("/var/www/pec-uz.uz/www/frontend/pages/franchise/components/partnerBlock/BlockDescription.vue")
  },
  {
    name: "franchise-components-partnerBlock-BlockDescription___en",
    path: "/en/franchise/components/partnerBlock/BlockDescription",
    component: () => import("/var/www/pec-uz.uz/www/frontend/pages/franchise/components/partnerBlock/BlockDescription.vue")
  },
  {
    name: "franchise-components-partnerBlock-BlockDescription___ru",
    path: "/ru/franchise/components/partnerBlock/BlockDescription",
    component: () => import("/var/www/pec-uz.uz/www/frontend/pages/franchise/components/partnerBlock/BlockDescription.vue")
  },
  {
    name: "franchise-components-partnerBlock-PartnersBlock___uz",
    path: "/franchise/components/partnerBlock/PartnersBlock",
    component: () => import("/var/www/pec-uz.uz/www/frontend/pages/franchise/components/partnerBlock/PartnersBlock.vue")
  },
  {
    name: "franchise-components-partnerBlock-PartnersBlock___en",
    path: "/en/franchise/components/partnerBlock/PartnersBlock",
    component: () => import("/var/www/pec-uz.uz/www/frontend/pages/franchise/components/partnerBlock/PartnersBlock.vue")
  },
  {
    name: "franchise-components-partnerBlock-PartnersBlock___ru",
    path: "/ru/franchise/components/partnerBlock/PartnersBlock",
    component: () => import("/var/www/pec-uz.uz/www/frontend/pages/franchise/components/partnerBlock/PartnersBlock.vue")
  },
  {
    name: "franchise-components-pekPlus-PalletBlock___uz",
    path: "/franchise/components/pekPlus/PalletBlock",
    component: () => import("/var/www/pec-uz.uz/www/frontend/pages/franchise/components/pekPlus/PalletBlock.vue")
  },
  {
    name: "franchise-components-pekPlus-PalletBlock___en",
    path: "/en/franchise/components/pekPlus/PalletBlock",
    component: () => import("/var/www/pec-uz.uz/www/frontend/pages/franchise/components/pekPlus/PalletBlock.vue")
  },
  {
    name: "franchise-components-pekPlus-PalletBlock___ru",
    path: "/ru/franchise/components/pekPlus/PalletBlock",
    component: () => import("/var/www/pec-uz.uz/www/frontend/pages/franchise/components/pekPlus/PalletBlock.vue")
  },
  {
    name: "franchise-components-pekPlus-PekPlusBlock___uz",
    path: "/franchise/components/pekPlus/PekPlusBlock",
    component: () => import("/var/www/pec-uz.uz/www/frontend/pages/franchise/components/pekPlus/PekPlusBlock.vue")
  },
  {
    name: "franchise-components-pekPlus-PekPlusBlock___en",
    path: "/en/franchise/components/pekPlus/PekPlusBlock",
    component: () => import("/var/www/pec-uz.uz/www/frontend/pages/franchise/components/pekPlus/PekPlusBlock.vue")
  },
  {
    name: "franchise-components-pekPlus-PekPlusBlock___ru",
    path: "/ru/franchise/components/pekPlus/PekPlusBlock",
    component: () => import("/var/www/pec-uz.uz/www/frontend/pages/franchise/components/pekPlus/PekPlusBlock.vue")
  },
  {
    name: "franchise___uz",
    path: "/franchise",
    component: () => import("/var/www/pec-uz.uz/www/frontend/pages/franchise/index.vue")
  },
  {
    name: "franchise___en",
    path: "/en/franchise",
    component: () => import("/var/www/pec-uz.uz/www/frontend/pages/franchise/index.vue")
  },
  {
    name: "franchise___ru",
    path: "/ru/franchise",
    component: () => import("/var/www/pec-uz.uz/www/frontend/pages/franchise/index.vue")
  },
  {
    name: "index-components-AdvantageBlock___uz",
    path: "//components/AdvantageBlock",
    component: () => import("/var/www/pec-uz.uz/www/frontend/pages/index/components/AdvantageBlock.vue")
  },
  {
    name: "index-components-AdvantageBlock___en",
    path: "/en//components/AdvantageBlock",
    component: () => import("/var/www/pec-uz.uz/www/frontend/pages/index/components/AdvantageBlock.vue")
  },
  {
    name: "index-components-AdvantageBlock___ru",
    path: "/ru//components/AdvantageBlock",
    component: () => import("/var/www/pec-uz.uz/www/frontend/pages/index/components/AdvantageBlock.vue")
  },
  {
    name: "index-components-BannerSlider___uz",
    path: "//components/BannerSlider",
    component: () => import("/var/www/pec-uz.uz/www/frontend/pages/index/components/BannerSlider.vue")
  },
  {
    name: "index-components-BannerSlider___en",
    path: "/en//components/BannerSlider",
    component: () => import("/var/www/pec-uz.uz/www/frontend/pages/index/components/BannerSlider.vue")
  },
  {
    name: "index-components-BannerSlider___ru",
    path: "/ru//components/BannerSlider",
    component: () => import("/var/www/pec-uz.uz/www/frontend/pages/index/components/BannerSlider.vue")
  },
  {
    name: "index-components-BlockTitle___uz",
    path: "//components/BlockTitle",
    component: () => import("/var/www/pec-uz.uz/www/frontend/pages/index/components/BlockTitle.vue")
  },
  {
    name: "index-components-BlockTitle___en",
    path: "/en//components/BlockTitle",
    component: () => import("/var/www/pec-uz.uz/www/frontend/pages/index/components/BlockTitle.vue")
  },
  {
    name: "index-components-BlockTitle___ru",
    path: "/ru//components/BlockTitle",
    component: () => import("/var/www/pec-uz.uz/www/frontend/pages/index/components/BlockTitle.vue")
  },
  {
    name: "index-components-ConsultationBlock___uz",
    path: "//components/ConsultationBlock",
    component: () => import("/var/www/pec-uz.uz/www/frontend/pages/index/components/ConsultationBlock.vue")
  },
  {
    name: "index-components-ConsultationBlock___en",
    path: "/en//components/ConsultationBlock",
    component: () => import("/var/www/pec-uz.uz/www/frontend/pages/index/components/ConsultationBlock.vue")
  },
  {
    name: "index-components-ConsultationBlock___ru",
    path: "/ru//components/ConsultationBlock",
    component: () => import("/var/www/pec-uz.uz/www/frontend/pages/index/components/ConsultationBlock.vue")
  },
  {
    name: "index-components-ConsultationForm___uz",
    path: "//components/ConsultationForm",
    component: () => import("/var/www/pec-uz.uz/www/frontend/pages/index/components/ConsultationForm.vue")
  },
  {
    name: "index-components-ConsultationForm___en",
    path: "/en//components/ConsultationForm",
    component: () => import("/var/www/pec-uz.uz/www/frontend/pages/index/components/ConsultationForm.vue")
  },
  {
    name: "index-components-ConsultationForm___ru",
    path: "/ru//components/ConsultationForm",
    component: () => import("/var/www/pec-uz.uz/www/frontend/pages/index/components/ConsultationForm.vue")
  },
  {
    name: "index-components-ModalError___uz",
    path: "//components/ModalError",
    component: () => import("/var/www/pec-uz.uz/www/frontend/pages/index/components/ModalError.vue")
  },
  {
    name: "index-components-ModalError___en",
    path: "/en//components/ModalError",
    component: () => import("/var/www/pec-uz.uz/www/frontend/pages/index/components/ModalError.vue")
  },
  {
    name: "index-components-ModalError___ru",
    path: "/ru//components/ModalError",
    component: () => import("/var/www/pec-uz.uz/www/frontend/pages/index/components/ModalError.vue")
  },
  {
    name: "index-components-ModalSuccess___uz",
    path: "//components/ModalSuccess",
    component: () => import("/var/www/pec-uz.uz/www/frontend/pages/index/components/ModalSuccess.vue")
  },
  {
    name: "index-components-ModalSuccess___en",
    path: "/en//components/ModalSuccess",
    component: () => import("/var/www/pec-uz.uz/www/frontend/pages/index/components/ModalSuccess.vue")
  },
  {
    name: "index-components-ModalSuccess___ru",
    path: "/ru//components/ModalSuccess",
    component: () => import("/var/www/pec-uz.uz/www/frontend/pages/index/components/ModalSuccess.vue")
  },
  {
    name: "index___uz",
    path: "/",
    component: () => import("/var/www/pec-uz.uz/www/frontend/pages/index/index.vue")
  },
  {
    name: "index___en",
    path: "/en",
    component: () => import("/var/www/pec-uz.uz/www/frontend/pages/index/index.vue")
  },
  {
    name: "index___ru",
    path: "/ru",
    component: () => import("/var/www/pec-uz.uz/www/frontend/pages/index/index.vue")
  },
  {
    name: "index-sections-DefaultAdvantagesSection___uz",
    path: "//sections/DefaultAdvantagesSection",
    component: () => import("/var/www/pec-uz.uz/www/frontend/pages/index/sections/DefaultAdvantagesSection.vue")
  },
  {
    name: "index-sections-DefaultAdvantagesSection___en",
    path: "/en//sections/DefaultAdvantagesSection",
    component: () => import("/var/www/pec-uz.uz/www/frontend/pages/index/sections/DefaultAdvantagesSection.vue")
  },
  {
    name: "index-sections-DefaultAdvantagesSection___ru",
    path: "/ru//sections/DefaultAdvantagesSection",
    component: () => import("/var/www/pec-uz.uz/www/frontend/pages/index/sections/DefaultAdvantagesSection.vue")
  },
  {
    name: "index-sections-DefaultHeaderSection___uz",
    path: "//sections/DefaultHeaderSection",
    component: () => import("/var/www/pec-uz.uz/www/frontend/pages/index/sections/DefaultHeaderSection.vue")
  },
  {
    name: "index-sections-DefaultHeaderSection___en",
    path: "/en//sections/DefaultHeaderSection",
    component: () => import("/var/www/pec-uz.uz/www/frontend/pages/index/sections/DefaultHeaderSection.vue")
  },
  {
    name: "index-sections-DefaultHeaderSection___ru",
    path: "/ru//sections/DefaultHeaderSection",
    component: () => import("/var/www/pec-uz.uz/www/frontend/pages/index/sections/DefaultHeaderSection.vue")
  },
  {
    name: "index-sections-DescriptionSection___uz",
    path: "//sections/DescriptionSection",
    component: () => import("/var/www/pec-uz.uz/www/frontend/pages/index/sections/DescriptionSection.vue")
  },
  {
    name: "index-sections-DescriptionSection___en",
    path: "/en//sections/DescriptionSection",
    component: () => import("/var/www/pec-uz.uz/www/frontend/pages/index/sections/DescriptionSection.vue")
  },
  {
    name: "index-sections-DescriptionSection___ru",
    path: "/ru//sections/DescriptionSection",
    component: () => import("/var/www/pec-uz.uz/www/frontend/pages/index/sections/DescriptionSection.vue")
  },
  {
    name: "index-sections-FaqSection___uz",
    path: "//sections/FaqSection",
    component: () => import("/var/www/pec-uz.uz/www/frontend/pages/index/sections/FaqSection.vue")
  },
  {
    name: "index-sections-FaqSection___en",
    path: "/en//sections/FaqSection",
    component: () => import("/var/www/pec-uz.uz/www/frontend/pages/index/sections/FaqSection.vue")
  },
  {
    name: "index-sections-FaqSection___ru",
    path: "/ru//sections/FaqSection",
    component: () => import("/var/www/pec-uz.uz/www/frontend/pages/index/sections/FaqSection.vue")
  },
  {
    name: "index-sections-InfoSection___uz",
    path: "//sections/InfoSection",
    component: () => import("/var/www/pec-uz.uz/www/frontend/pages/index/sections/InfoSection.vue")
  },
  {
    name: "index-sections-InfoSection___en",
    path: "/en//sections/InfoSection",
    component: () => import("/var/www/pec-uz.uz/www/frontend/pages/index/sections/InfoSection.vue")
  },
  {
    name: "index-sections-InfoSection___ru",
    path: "/ru//sections/InfoSection",
    component: () => import("/var/www/pec-uz.uz/www/frontend/pages/index/sections/InfoSection.vue")
  },
  {
    name: "index-sections-MapSection___uz",
    path: "//sections/MapSection",
    component: () => import("/var/www/pec-uz.uz/www/frontend/pages/index/sections/MapSection.vue")
  },
  {
    name: "index-sections-MapSection___en",
    path: "/en//sections/MapSection",
    component: () => import("/var/www/pec-uz.uz/www/frontend/pages/index/sections/MapSection.vue")
  },
  {
    name: "index-sections-MapSection___ru",
    path: "/ru//sections/MapSection",
    component: () => import("/var/www/pec-uz.uz/www/frontend/pages/index/sections/MapSection.vue")
  },
  {
    name: "index-utils-getAddressInfo___uz",
    path: "//utils/getAddressInfo",
    component: () => import("/var/www/pec-uz.uz/www/frontend/pages/index/utils/getAddressInfo.js")
  },
  {
    name: "index-utils-getAddressInfo___en",
    path: "/en//utils/getAddressInfo",
    component: () => import("/var/www/pec-uz.uz/www/frontend/pages/index/utils/getAddressInfo.js")
  },
  {
    name: "index-utils-getAddressInfo___ru",
    path: "/ru//utils/getAddressInfo",
    component: () => import("/var/www/pec-uz.uz/www/frontend/pages/index/utils/getAddressInfo.js")
  },
  {
    name: "index-utils-getDirectionParamsFromAddressInfo___uz",
    path: "//utils/getDirectionParamsFromAddressInfo",
    component: () => import("/var/www/pec-uz.uz/www/frontend/pages/index/utils/getDirectionParamsFromAddressInfo.js")
  },
  {
    name: "index-utils-getDirectionParamsFromAddressInfo___en",
    path: "/en//utils/getDirectionParamsFromAddressInfo",
    component: () => import("/var/www/pec-uz.uz/www/frontend/pages/index/utils/getDirectionParamsFromAddressInfo.js")
  },
  {
    name: "index-utils-getDirectionParamsFromAddressInfo___ru",
    path: "/ru//utils/getDirectionParamsFromAddressInfo",
    component: () => import("/var/www/pec-uz.uz/www/frontend/pages/index/utils/getDirectionParamsFromAddressInfo.js")
  },
  {
    name: "index-utils-getNeedCalculate___uz",
    path: "//utils/getNeedCalculate",
    component: () => import("/var/www/pec-uz.uz/www/frontend/pages/index/utils/getNeedCalculate.js")
  },
  {
    name: "index-utils-getNeedCalculate___en",
    path: "/en//utils/getNeedCalculate",
    component: () => import("/var/www/pec-uz.uz/www/frontend/pages/index/utils/getNeedCalculate.js")
  },
  {
    name: "index-utils-getNeedCalculate___ru",
    path: "/ru//utils/getNeedCalculate",
    component: () => import("/var/www/pec-uz.uz/www/frontend/pages/index/utils/getNeedCalculate.js")
  },
  {
    name: "index-utils-getSugggest___uz",
    path: "//utils/getSugggest",
    component: () => import("/var/www/pec-uz.uz/www/frontend/pages/index/utils/getSugggest.js")
  },
  {
    name: "index-utils-getSugggest___en",
    path: "/en//utils/getSugggest",
    component: () => import("/var/www/pec-uz.uz/www/frontend/pages/index/utils/getSugggest.js")
  },
  {
    name: "index-utils-getSugggest___ru",
    path: "/ru//utils/getSugggest",
    component: () => import("/var/www/pec-uz.uz/www/frontend/pages/index/utils/getSugggest.js")
  },
  {
    name: "index-utils-getTransitCostBlockMessage___uz",
    path: "//utils/getTransitCostBlockMessage",
    component: () => import("/var/www/pec-uz.uz/www/frontend/pages/index/utils/getTransitCostBlockMessage.js")
  },
  {
    name: "index-utils-getTransitCostBlockMessage___en",
    path: "/en//utils/getTransitCostBlockMessage",
    component: () => import("/var/www/pec-uz.uz/www/frontend/pages/index/utils/getTransitCostBlockMessage.js")
  },
  {
    name: "index-utils-getTransitCostBlockMessage___ru",
    path: "/ru//utils/getTransitCostBlockMessage",
    component: () => import("/var/www/pec-uz.uz/www/frontend/pages/index/utils/getTransitCostBlockMessage.js")
  },
  {
    name: "index-utils-isProductCode___uz",
    path: "//utils/isProductCode",
    component: () => import("/var/www/pec-uz.uz/www/frontend/pages/index/utils/isProductCode.js")
  },
  {
    name: "index-utils-isProductCode___en",
    path: "/en//utils/isProductCode",
    component: () => import("/var/www/pec-uz.uz/www/frontend/pages/index/utils/isProductCode.js")
  },
  {
    name: "index-utils-isProductCode___ru",
    path: "/ru//utils/isProductCode",
    component: () => import("/var/www/pec-uz.uz/www/frontend/pages/index/utils/isProductCode.js")
  },
  {
    name: "news-id___uz",
    path: "/news/:id()",
    meta: _91id_93R8DA5OsUbSMeta || {},
    component: () => import("/var/www/pec-uz.uz/www/frontend/pages/news/[id].vue")
  },
  {
    name: "news-id___en",
    path: "/en/news/:id()",
    meta: _91id_93R8DA5OsUbSMeta || {},
    component: () => import("/var/www/pec-uz.uz/www/frontend/pages/news/[id].vue")
  },
  {
    name: "news-id___ru",
    path: "/ru/news/:id()",
    meta: _91id_93R8DA5OsUbSMeta || {},
    component: () => import("/var/www/pec-uz.uz/www/frontend/pages/news/[id].vue")
  },
  {
    name: "news___uz",
    path: "/news",
    meta: index220KgIhFRnMeta || {},
    component: () => import("/var/www/pec-uz.uz/www/frontend/pages/news/index.vue")
  },
  {
    name: "news___en",
    path: "/en/news",
    meta: index220KgIhFRnMeta || {},
    component: () => import("/var/www/pec-uz.uz/www/frontend/pages/news/index.vue")
  },
  {
    name: "news___ru",
    path: "/ru/news",
    meta: index220KgIhFRnMeta || {},
    component: () => import("/var/www/pec-uz.uz/www/frontend/pages/news/index.vue")
  },
  {
    name: "package-components-Category___uz",
    path: "/package/components/Category",
    component: () => import("/var/www/pec-uz.uz/www/frontend/pages/package/components/Category.vue")
  },
  {
    name: "package-components-Category___en",
    path: "/en/package/components/Category",
    component: () => import("/var/www/pec-uz.uz/www/frontend/pages/package/components/Category.vue")
  },
  {
    name: "package-components-Category___ru",
    path: "/ru/package/components/Category",
    component: () => import("/var/www/pec-uz.uz/www/frontend/pages/package/components/Category.vue")
  },
  {
    name: "package-components-CategoryPallet___uz",
    path: "/package/components/CategoryPallet",
    component: () => import("/var/www/pec-uz.uz/www/frontend/pages/package/components/CategoryPallet.vue")
  },
  {
    name: "package-components-CategoryPallet___en",
    path: "/en/package/components/CategoryPallet",
    component: () => import("/var/www/pec-uz.uz/www/frontend/pages/package/components/CategoryPallet.vue")
  },
  {
    name: "package-components-CategoryPallet___ru",
    path: "/ru/package/components/CategoryPallet",
    component: () => import("/var/www/pec-uz.uz/www/frontend/pages/package/components/CategoryPallet.vue")
  },
  {
    name: "package-components-PalletBlock___uz",
    path: "/package/components/PalletBlock",
    component: () => import("/var/www/pec-uz.uz/www/frontend/pages/package/components/PalletBlock.vue")
  },
  {
    name: "package-components-PalletBlock___en",
    path: "/en/package/components/PalletBlock",
    component: () => import("/var/www/pec-uz.uz/www/frontend/pages/package/components/PalletBlock.vue")
  },
  {
    name: "package-components-PalletBlock___ru",
    path: "/ru/package/components/PalletBlock",
    component: () => import("/var/www/pec-uz.uz/www/frontend/pages/package/components/PalletBlock.vue")
  },
  {
    name: "package-components-TableSearch-HeadWithSearch___uz",
    path: "/package/components/TableSearch/HeadWithSearch",
    component: () => import("/var/www/pec-uz.uz/www/frontend/pages/package/components/TableSearch/HeadWithSearch.vue")
  },
  {
    name: "package-components-TableSearch-HeadWithSearch___en",
    path: "/en/package/components/TableSearch/HeadWithSearch",
    component: () => import("/var/www/pec-uz.uz/www/frontend/pages/package/components/TableSearch/HeadWithSearch.vue")
  },
  {
    name: "package-components-TableSearch-HeadWithSearch___ru",
    path: "/ru/package/components/TableSearch/HeadWithSearch",
    component: () => import("/var/www/pec-uz.uz/www/frontend/pages/package/components/TableSearch/HeadWithSearch.vue")
  },
  {
    name: "package-components-TableSearch-TableBlock___uz",
    path: "/package/components/TableSearch/TableBlock",
    component: () => import("/var/www/pec-uz.uz/www/frontend/pages/package/components/TableSearch/TableBlock.vue")
  },
  {
    name: "package-components-TableSearch-TableBlock___en",
    path: "/en/package/components/TableSearch/TableBlock",
    component: () => import("/var/www/pec-uz.uz/www/frontend/pages/package/components/TableSearch/TableBlock.vue")
  },
  {
    name: "package-components-TableSearch-TableBlock___ru",
    path: "/ru/package/components/TableSearch/TableBlock",
    component: () => import("/var/www/pec-uz.uz/www/frontend/pages/package/components/TableSearch/TableBlock.vue")
  },
  {
    name: "package-components-TableSearch-TableRow___uz",
    path: "/package/components/TableSearch/TableRow",
    component: () => import("/var/www/pec-uz.uz/www/frontend/pages/package/components/TableSearch/TableRow.vue")
  },
  {
    name: "package-components-TableSearch-TableRow___en",
    path: "/en/package/components/TableSearch/TableRow",
    component: () => import("/var/www/pec-uz.uz/www/frontend/pages/package/components/TableSearch/TableRow.vue")
  },
  {
    name: "package-components-TableSearch-TableRow___ru",
    path: "/ru/package/components/TableSearch/TableRow",
    component: () => import("/var/www/pec-uz.uz/www/frontend/pages/package/components/TableSearch/TableRow.vue")
  },
  {
    name: "package-components-TableSearch-TableSearch___uz",
    path: "/package/components/TableSearch/TableSearch",
    component: () => import("/var/www/pec-uz.uz/www/frontend/pages/package/components/TableSearch/TableSearch.vue")
  },
  {
    name: "package-components-TableSearch-TableSearch___en",
    path: "/en/package/components/TableSearch/TableSearch",
    component: () => import("/var/www/pec-uz.uz/www/frontend/pages/package/components/TableSearch/TableSearch.vue")
  },
  {
    name: "package-components-TableSearch-TableSearch___ru",
    path: "/ru/package/components/TableSearch/TableSearch",
    component: () => import("/var/www/pec-uz.uz/www/frontend/pages/package/components/TableSearch/TableSearch.vue")
  },
  {
    name: "package___uz",
    path: "/package",
    component: () => import("/var/www/pec-uz.uz/www/frontend/pages/package/index.vue")
  },
  {
    name: "package___en",
    path: "/en/package",
    component: () => import("/var/www/pec-uz.uz/www/frontend/pages/package/index.vue")
  },
  {
    name: "package___ru",
    path: "/ru/package",
    component: () => import("/var/www/pec-uz.uz/www/frontend/pages/package/index.vue")
  }
]